import { css } from '@emotion/react';
import { InlineNotification, Text } from '@frontend/design-system';

type Props = {
  title: string;
  description: React.ReactNode | null;
};

export const PreviewNotification = ({ title, description }: Props) => {
  return (
    <InlineNotification status='info' css={previewNotificationStyles}>
      <Text size='medium'>
        <strong>{title}</strong> {description}
      </Text>
    </InlineNotification>
  );
};

const previewNotificationStyles = css({
  maxHeight: 'none',
  maxWidth: 'none',
  width: '100%',
  '> div': { width: '100%' },
});

export const PreviewText = ({ title, description, ...rest }: Props) => {
  return (
    <Text size='medium' css={previewTextStyles} {...rest}>
      <strong>{title}</strong> {description}
    </Text>
  );
};

const previewTextStyles = css({
  marginTop: 'var(--fabric-space-gap-xs)',
});
